export class ProCompInputDataValidationError extends Error {
  readonly tag = 'ProCompInputDataValidationError';
}
